<template>
  <div class="d-flex justify-content-center align-items-center" id="main">
    <h1
      class="mr-3 pr-3 align-top border-right inline-block align-content-center"
    >
      About 
    </h1>
    &nbsp;&nbsp;
    <div class="inline-block align-middle">
      <h2 class="font-weight-normal lead" id="desc">
       Of Us
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  mounted() {},
  methods: {},
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main {
  height: 100vh;
}
</style>
